// External Dependencies
import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
} from 'redux';
import thunk from 'redux-thunk';

// Internal Dependencies
import badges from './reducers/badges-reducer';
import coderAttendance from './reducers/coder-attendance-reducer';
import coderBadges from './reducers/coder-badges-reducer';
import coders from './reducers/coders-reducer';
import coderSingle from './reducers/coder-single-reducer';
import eventData from './reducers/event-reducer';
import ui from './ui/reducers';

const reducers = {
  badges,
  coders,
  coderAttendance,
  coderBadges,
  coderSingle,
  eventData,
  ui,
};

// Create the root reducer
const reducer = combineReducers(reducers);

// Include redux dev tools in the store enhancer if on development
const initialStoreEnhancer = () => {
  const storeEnhancer = process.env.NODE_ENV === 'development'
    ? compose(
        applyMiddleware(
          thunk,
        ),
        // eslint-disable-next-line global-require
        require('../redux-dev-tools').default.instrument(),
      )
    : applyMiddleware(
      thunk,
    );

  return storeEnhancer;
};


// const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

const initializeStore = intialState =>
  createStore(reducer, intialState, initialStoreEnhancer());

export default initializeStore;



/** WEBPACK FOOTER **
 ** ./src/state/index.js
 **/